<template>
  <el-form ref="form" :model="Contractform" :inline="true" class="queryHeader">
    <el-row>
      <el-col :span="6">
        <el-form-item label="合同编号" label-width="120px">
          <el-input
            v-model="Contractform.serialNumber"
            placeholder="-请输入"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="供应商" label-width="120px">
          <el-input
            v-model="Contractform.partyB"
            placeholder="-请输入"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="所属项目" label-width="120px">
          <el-input
            v-model="Contractform.projectName"
            placeholder="-请输入"
          ></el-input>
        </el-form-item>
      </el-col>
      <div v-if="showAdvanceFilter">
        <el-col :span="6">
          <el-form-item label="合同名称" label-width="120px">
            <el-input
              v-model="Contractform.name"
              placeholder="-请输入-"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="合同金额" label-width="120px">
            <el-input v-model="Contractform.amountStart" style="width:calc(45% - 12px)"></el-input>
         ——
            <el-input v-model="Contractform.amountEnd" style="width:calc(45% - 12px)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请人" label-width="120px">
            <el-input
              v-model="Contractform.applyUserName"
              placeholder="-请输入-"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="签订日期" label-width="120px">
            <el-date-picker
              v-model="Contractform.signDate"
              type="daterange"
              range-separator="至"
              @blur="handleTimestamp"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="截至日期"
              >></el-date-picker
            >
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态" label-width="120px">
            <el-select
              size="small"
              v-model="Contractform.approveStatus"
              collapse-tags
              placeholder="请选择"
            >
              <el-option label="草稿" value="5"></el-option>
              <el-option label="撤回" value="1"></el-option>
              <el-option label="待审核" value="2"></el-option>
              <el-option label="已完成" value="3"></el-option>
              <el-option label="已驳回" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请部门" label-width="120px">
            <el-cascader
              v-model="Contractform.applyDeptName"
              :options="subDeptList"
              :props="defaultProps"
              @change="handleChange"
              placeholder="请选择"
              @active-item-change="handleChange"
              change-on-select
              :editable="false"
            ></el-cascader>
          </el-form-item>
        </el-col>
      </div>
      <el-col :span="showAdvanceFilter ? 18 : 6">
        <div class="btnWrap">
          <el-button type="primary" icon @click="searchData()">查询</el-button>
          <el-button type="info" icon @click="clearSearchConditions"
            >重置</el-button
          >
          <el-button type="text" @click="moreScreen">{{
            showAdvanceFilter ? "收起" : "高级筛选"
          }}</el-button>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { getAreaGroup, getsubDeptService } from "@/services/sysSettingService";

export default {
  name: "queryHeader",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //查询条件form
      Contractform: {
        id: "",
        serialNumber: "", // 合同编号
        name: "", //合同名称
        partyA: "", //合同甲方
        partyB: "", //合同乙方
        advancePayPct: "", //预付款比例
        amountTax: "", //税金
        amountWithoutTax: "", //除税合同金额
        applyDeptId: "", //申请人部门ID
        applyDeptName: "", //申请人部门ID
        applyUserId: "", //申请人ID
        applyUserName: "", //申请人姓名
        approveStatus: "", //审批状态编码
        approveStatusName: "", //审批状态名称
        approveUserId: "", //当前审批人
        signDate: "", //签订日期
        signDateStart: "", //签订时间起
        signDateEnd: "", //签订时间止
        signPlace: "", //签订地点
        amount: "", //合同金额
        amountStart: "", //
        amountEnd: "", //
        comments: "", //备注
        agreeOn: "", //付款约定
        content: "", //合同内容
        contractPeriod: "", //合同期限
        predictAmount: "", //单价合同预估数量
        predictPrice: "", //单价合同预估金额
        priceType: "", //1单价合同 2总价合同
        projectId: "", //所属项目id
        projectName: "", //所属项目
        taxRate: "", //税率
        totalAmount: "", //总价合同总金额
        type: this.type, //分项合同类型，LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
      },
      subDeptList: [], //子部门列表
      showAdvanceFilter: false,
      defaultProps: {
        label: "name",
        value: "name",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (node.value) {
            param.deptId = node.data.id;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
    };
  },
  // watch: {
  //   type(newVal) {
  //     this.Contractform.type = newVal;
	// 		this.$emit("queryData", this.Contractform);
  //   },
  // },
  created() {
    let pid = 0;
    this.getsubListData(pid);
  },
	mounted(){
		this.Contractform.type = this.type;
    // if(this.type)
    // {
    //   this.$emit("queryData", this.Contractform);
    // }
			
	},
  methods: {
    handleChange(value) {
      //  Projectform.applyDeptId = value;
      let len = value.length;
      this.Contractform.applyDeptName = value[len - 1];
    },
    //获取子部门下拉列表数据
    getsubListData(deptId) {
      let reqParam = {
        deptId: deptId,
      };
      getsubDeptService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //高级筛选
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
    },
    //查询
    searchData() {
      this.$emit("queryData", this.Contractform);
    },
    //重置查询条件
    clearSearchConditions() {
      for (let key in this.Contractform) {
        if (key != "type") {
          this.Contractform[key] = "";
        }
      }
      this.$emit("queryData", this.Contractform);
    },
  },
};
</script>

<style scoped lang="scss">
.queryHeader {
  // border-bottom: 1px solid #e6e6e6;
	margin-top: 16px;

  /deep/ .el-form-item {
    width: 100%;
    margin-right: 0;

    .el-form-item__content {
      width: calc(100% - 120px);

      .el-select {
        width: 100%;
      }
			.el-cascader{
				width: 100%;
			}

      .el-date-editor {
        width: 100%;
      }
      
    }

		.el-button--primary {
        padding: 10px 3px;
      }
  }

  .btnWrap {
    text-align: right;
  }
}
</style>
